import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Linkify from 'react-linkify';
import debounce from 'lodash.debounce';
import i18next from 'i18next';
import Anchor from '../Anchor/Anchor';
import '../CommentText/CommentText.css';

export default class Truncate extends PureComponent {
  constructor(props) {
    super(props);

    const { text, delay } = props;

    this.element = null;
    this.watch = true;
    this.lineHeight = 0;
    this.state = {
      noClamp: false,
      text: text.substring(0, 20)
    };

    this.debounced = debounce(this.performClampLines, delay);
  }

  componentDidMount() {
    const { text } = this.props;
    if (text) {
      this.lineHeight = this.element.clientHeight;
      this.clampLines();

      if (this.watch) {
        window.addEventListener('resize', this.debounced);
      }
    }
  }

  componentDidUpdate(prevProps) {
    const { text } = this.props;
    if (prevProps.text !== text) {
      this.clampLines();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.debounced);
  }

  performClampLines = () => {
    if (this.watch) {
      this.clampLines();
    }
  };

  clampLines = () => {
    if (!this.element) return;
    this.setState({
      text: ''
    });

    const { lines, text: textFromProps } = this.props;
    const maxHeight = this.lineHeight * lines + 1;

    let start = 0;
    let middle = 0;
    let end = textFromProps.length;
    while (start <= end) {
      middle = Math.floor((start + end) / 2);
      this.element.innerText = textFromProps.slice(0, middle);
      if (middle === textFromProps.length) {
        // Getting here it means we dont want the text to be truncated
        this.setState({
          text: textFromProps,
          noClamp: true
        });
        return;
      }

      if (this.element.clientHeight <= maxHeight) {
        start = middle + 1;
      } else {
        end = middle - 1;
      }
    }

    const truncatedText =
      textFromProps.slice(0, middle - 5) + this.getEllipsis();
    this.element.innerText = truncatedText;
    this.setState({
      text: truncatedText,
      noClamp: false
    });
  };

  getEllipsis = () => {
    const { noClamp } = this.state;
    const { ellipsis } = this.props;
    return this.watch && !noClamp ? ellipsis : '';
  };

  getButton = () => {
    const { noClamp } = this.state;
    const { buttons } = this.props;
    if (noClamp || !buttons || !this.watch) return null;

    return (
      <button
        type="button"
        styleName="truncate-button"
        onClick={this.clickHandler}
      >
        {i18next.t('seeMore')}
      </button>
    );
  };

  clickHandler = () => {
    this.watch = !this.watch;
    if (this.watch) {
      this.clampLines();
    } else {
      const { text } = this.props;
      this.setState({
        text
      });
    }
  };

  componentDecorator = (href, text, key) => (
    <span styleName="comment-link" key={key}>
      <Anchor href={href} newTab>
        {text}
      </Anchor>
    </span>
  );

  setRef = (ref) => {
    this.element = ref;
  };

  render() {
    const { text: textFromState } = this.state;
    return (
      <div styleName="truncate-container">
        <Linkify componentDecorator={this.componentDecorator}>
          <p ref={this.setRef} styleName="comment-text">
            {textFromState}
          </p>
          {this.getButton()}
        </Linkify>
      </div>
    );
  }
}

Truncate.propTypes = {
  text: PropTypes.string,
  lines: PropTypes.number,
  ellipsis: PropTypes.string,
  buttons: PropTypes.bool,
  delay: PropTypes.number
};

Truncate.defaultProps = {
  text: '',
  lines: 2,
  ellipsis: '...',
  buttons: true,
  delay: 300
};
